import { render, staticRenderFns } from "./ContentCopy.vue?vue&type=template&id=8337162c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContentCopy.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/ContentCopy.vue
// module id = 1703
// module chunks = 1